import React from "react"

const BgParallax = ({ children, gradient, image }) => {
  return (
    <section
      className="bg-green py-5"
      style={{
        background: `${gradient}, ${image} no-repeat center fixed`,
        backgroundSize: "cover",
      }}
    >
      {children}
    </section>
  )
}

export default BgParallax
